import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TealiumService } from '@app/services/tealium.service';
import { ConfigService } from '@ng-darwin/config';
import { SecurityService } from '@ng-darwin/security';

/**
 * @description Component
 * @class AgTermsConditionsComponent
 * @implements {OnInit} OnInit
 */
@Component({
  standalone: false,
  selector: 'app-ag-terms-conditions',
  templateUrl: './ag-terms-conditions.component.html',
  styleUrls: ['./ag-terms-conditions.component.scss']
})
export class AgTermsConditionsComponent implements OnInit {

  @Output() buttonCancel: EventEmitter<any> = new EventEmitter();
  @Output() buttonAllow: EventEmitter<any> = new EventEmitter();
  @Output() buttonAllowSantander: EventEmitter<any> = new EventEmitter();
  public isCompanyUser = false;
  /**
   * @description Creates an instance of AgTermsConditionsComponent.
   * @param _configService ConfigService
   * @param _securityService SecurityService
   * @param _tealiumService TealiumService
   */
  constructor(
    private readonly _configService: ConfigService,
    private readonly _securityService: SecurityService,
    private readonly _tealiumService: TealiumService,
  ) { }

  /**
   * @description ngOnInit
   */
  ngOnInit(): void {
    const token = this._securityService.token || '';
    const parsedToken = atob(token).split('#');
    const config = this._configService.config.app['companyUserTypes'] as string[] || [];
    config.forEach(type => {
      if (parsedToken.some((t) => t === type)) {
        this.isCompanyUser = true;
        (window as any).utag_data.site_hierarchy = 'empresas';
      } else {
        (window as any).utag_data.site_hierarchy = 'particulares';
      }
    });
    this._tealiumService.sendPageLoad({
      page_name: '/PSD2/condiciones',
      page_title: 'PSD2 Condiciones',
      page_type: 'detalle',
      page_category: 'servicing',
      product_scope: 'operativa_no_financiera',
      product_category: 'PSD2',
      product_name: 'crédito digital',
      site_hierarchy: this.isCompanyUser ? 'empresas' : 'particulares',
    });
  }

  /**
   * @description emitCancel
   */
  emitCancel(): void {
    this._tealiumService.sendEvent({
      category: 'PSD2 Agregador',
      action: 'select_content',
      data: {
        product_name: 'crédito digital',
        product_category: 'PSD2',
        content_type: 'PSD2_agregador',
        item_id: 'click_no_consentir_agregación',
        label: 'Pulsa no_consentir agregación'
      }
    });
    this.buttonCancel.emit();
  }
  /**
   * @description emitAllow
   */
  emitAllow(): void {
    this._tealiumService.sendEvent({
      category: 'PSD2 Agregador',
      action: 'select_content',
      data: {
        product_name: 'crédito digital',
        product_category: 'PSD2',
        content_type: 'PSD2_agregador',
        item_id: 'click_consentir_agregación',
        label: 'Pulsa consentir agregación'
      }
    });
    this.buttonAllow.emit();
  }

  /**
   * @description Flags the flow as Santander-only and emits a dedicated event so the parent skips the bank-selection screen
   * @param event MouseEvent
   */
  emitAllowSantander(event: MouseEvent): void {
    event.preventDefault();
    this._tealiumService.sendEvent({
      category: 'PSD2 Agregador',
      action: 'select_content',
      data: {
        product_name: 'crédito digital',
        product_category: 'PSD2',
        content_type: 'PSD2_agregador',
        item_id: 'click_consentir_agregación_solo_cuenta_santander',
        label: 'Pulsa solo tengo cuenta en el Santander'
      }
    });
    sessionStorage.setItem('onlySantander', 'true');
    this.buttonAllowSantander.emit();
  }
}
